<template>
  <div v-if="acessoPermitido" class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Abonos</h4>
          <div>
            <div class="justify-content-sm-between text-left mb-3">
              <el-select class="select-success pagination-select col-12 col-sm-3 m-0 b-0" v-model="status_abono"
                placeholder="Status do Abono">
                <el-option class="select-success" v-for="item in tipos_abono" :key="item.valor" :label="item.descricao"
                  :value="item.valor">
                </el-option>
              </el-select>
              <base-button type="success" class="animation-on-hover col-12 col-sm-2 m-0 b-0"
                @click.native="listarAbono()">Pesquisar Abono</base-button>
            </div>

            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div>
                <el-select class="select-success mb-3 pagination-select" v-model="pagination.perPage"
                  placeholder="Per page">
                  <el-option class="select-success" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                <div>
                  <base-button type="success" class="animation-on-hover" style="margin: 0px 5px 0px 5px;"
                    @click.native="$router.push('abono/inserir')">Enviar Abono</base-button>
                </div>
              </div>
            </div>
            <el-table :data="queriedData">
              <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth"
                :prop="column.prop" :label="column.label">
              </el-table-column>
              <el-table-column :min-width="100" align="right" label="Ações">
                <div slot-scope="props">
                  <base-button @click.native="
                    selecionarAbono(props.$index, props.row),
                    (dialogHorarioLimite = true),
                    (cadAlt = 'Alterar')
                    " class="edit btn-link" type="info" size="sm" icon>
                    <i class="tim-icons icon-image-02"></i>
                  </base-button>
                  <modal :show.sync="dialogHorarioLimite">
                    <template slot="header">
                      <h4 class="modal-title" id="exampleModalLabel">
                        Arquivo Enviado
                      </h4>
                    </template>
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <template v-if="isImage(abonoSelecionado.arquivo)">
                          <img :src="abonoSelecionado.arquivo" alt="Card image" class="img img-raised"
                            style="max-height: 80vh;" />
                        </template>
                        <template v-else>
                          <a
                            :href="abonoSelecionado.arquivo"
                            download
                            class="btn btn-success"
                          >
                            Baixar PDF
                          </a>
                        </template>
                      </div>
                    </div>
                  </modal>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} abonos.
              </p>
            </div>
            <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
              :per-page="pagination.perPage" :total="total">
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" loader="spinner" color="#35a887" :is-full-page="true">
      </loading>
    </div>
  </div>
  <div v-else-if="!acessoPermitido && !pageErro" class="content small">
    <modal v-if="showRecFacial" :show.sync="showRecFacial">
      <modal-rec-facial-2 width="80%" height="80%" />
    </modal>
  </div>
  <div v-else-if="pageErro" class="content small">
    <div class="flex flex-col items-center justify-center h-full">
      <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
        Acesso Negado
      </h1>
      <p class="text-gray-600 text-center">
        Você não tem permissão para acessar esta página.
      </p>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Card,
  BasePagination,
  BaseInput,
  ImageUpload
} from "@/components/index";
import {
  Table,
  TableColumn,
  Select,
  Option,
  TimeSelect,
  DatePicker
} from "element-ui";
import users from "../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import NotificationHorarioLimite from "./Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";
import ModalRecFacial2 from "../../src/pages/Components/ModalRecFacial2.vue";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    ImageUpload,

    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    BasePagination,
    BaseInput,
    Modal,
    ModalRecFacial2
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      abono: {
        data: "",
        hora: "",
        file: null
      },
      abonoSelecionado: [],
      horarioSelecionado: "",
      cadAlt: "",
      listAbonos: "",
      descricao: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["DESCRICAO_TIPO_ABONO"],
      tableColumns: [
        {
          prop: "DESCRICAO_TIPO_ABONO",
          label: "Tipo",
          minWidth: 250
        },
        {
          prop: "matricula",
          label: "Matrícula",
          minWidth: 100
        },
        {
          prop: "DATA_ABONO",
          label: "Data",
          minWidth: 200
        },
        {
          prop: "horas",
          label: "Horas",
          minWidth: 100
        },
        {
          prop: "status_abono",
          label: "Status",
          minWidth: 100
        }
      ],
      tableData: users,
      searchedData: [],
      fuseSearch: null,
      dados: "",
      status_abono: "A",
      tipos_abono: [{
        descricao: "Aguardando Aprovação",
        valor: "A"
      }, {
        descricao: "Aprovado",
        valor: "S"
      }, {
        descricao: "Reprovado",
        valor: "N"
      }],
      acessoPermitido: false,
      pageErro: false,
      showRecFacial: true
    };
  },
  mounted() {
    this.listarAbono();
    // this.notifyVue('top', 'center');
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "email"],
      threshold: 0.3
    });

    this.$root.$on("checkFacial", data => {
      try {
        if (data) {
          this.showRecFacial = false;
          this.acessoPermitido = true;
          this.pageErro = false; // Garante que a tela de erro não apareça
        } else {
          this.showRecFacial = false; // Fecha a modal de reconhecimento facial
          this.acessoPermitido = false; // Bloqueia o acesso
          this.pageErro = true; // Mostra a tela de acesso negado
        }
      } catch {
        this.showRecFacial = false;
        this.acessoPermitido = false;
        this.pageErro = true;
      }
    });
  },
  methods: {
    carregarDados() {
      this.dados = JSON.parse(this.$session.get("dados"));
    },
    onImageChange(file) {
      this.abono.file = file;
    },
    isImage(file) {

      return /^data:image\/(jpeg|png|gif);base64,/.test(file);
    },

    notifyVue(verticalAlign, horizontalAlign) {
      this.$notify({
        component: NotificationHorarioLimite,
        icon: "tim-icons icon-bell-55",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: "warning",
        timeout: 30000
      });
    },

    selecionarAbono(index, row) {
      this.abonoSelecionado = row;
    },

    listarAbono() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.dados.DB_NAME,
        id_empregado: this.dados.ID_EMPREGADO,
        id_empregador: this.dados.ID_EMPREGADOR,
        status_abono: this.status_abono
      };

      this.axios
        .post(
          "/api/abonos/listarAbonosPorIdEmpregadoIdEmpregador",
          bodyFormData
        )
        .then(response => {
          th.isLoading = false;

          th.tableData = response.data.data.dados.filter(dados => {
            if (dados.status_abono == "S") {
              dados.status_abono = "Aprovado";
            } else if (dados.status_abono == "N") {
              dados.status_abono = "Reprovado";
            } else {
              dados.status_abono = "Aguardando";
            }
            return dados;
          });
        })
        .catch(err => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao listar!", "error");
        });
    }
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    dialogHorarioLimite(value) { },
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },
  created() {
    this.carregarDados();
  }
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
